module.exports = __webpack_public_path__ + "img/messenger-instruction-1.deac064d.png";